export default __webpack_public_path__ + "static/media/19.33d96ae6.mp3";